
// Login model
export class LoginModel{
    IsADUser: boolean;
    Name:string;
    Password:string;
    constructor(){
    }
}


export class AppUserAuth {
    userName: string = "";
    id:string = "";
    securityToken: string = "";
    isAuthenticated: boolean = false;
    isAdmin:boolean = false;


  }



export interface Localization {
    LocalizationId: string;
    LanguageId: string;
    LanguageCodes: string;
    Name: string;
    Text: string;
}


export interface FieldList {
    TableDefinitionId: string;
    TableDefinitionFieldId: string;
    InternalName: string;
    Localizations: Localization[];
    DataType: number;
    EnumValuesXml?: any;
    IsInternal: boolean;
    IsEditable: boolean;
    IsRequired: boolean;
    ValidationRegEx: string;
    ValidationMin: number;
    ValidationMax: number;
}

export interface TableDefinition {
    TableDefinitionId: string;
    HardwareType?: any;
    ModuleType?: any;
    NodeType?: any;
    ProcessType?: any;
    ProcessEventType?: any;
    RuleType: number;
    InternalName: string;
    FieldList: FieldList[];
}



export interface TableDefinitionField {
    TableDefinitionId: string;
    TableDefinitionFieldId: string;
    InternalName: string;
    Localizations: Localization[];
    DataType: number;
    EnumValuesXml?: any;
    IsInternal: boolean;
    IsEditable: boolean;
    IsRequired: boolean;
    ValidationRegEx: string;
    ValidationMin: number;
    ValidationMax: number;
}

export interface DataElementList {
    DataId: string;
    TableDefinitionField: TableDefinitionField;
    Name: string;
    TextValue: string;
    DoubleValue: number;
    BoolValue: boolean;
}




/********************************Rule model ***************************/
export class RuleModelBase {
    RuleId: string;
    Localizations: Localization[];
    WebsiteNotification: boolean;
    EMailNotification: boolean;
    SmsNotification: boolean;
    RuleFunctionType: number;
    Limit: number;
    NotifficationUserList: any[];
    WatchNodeList: any[];
    AvailableTableDefinitions?: any;
    TableDefinition: TableDefinition;
    DataElementList: DataElementList[];
}


export class RuleModel extends RuleModelBase {
    LocalizationId: string;
    TranslationLocalizations: Localization[];
    Name:string;
    Text:string;
    Text2:string;
    Text3:string;
    TableDefinitionId: string;
    ModuleId: string;
    ruleTypId:number;
}

export interface NotifficationUserList {
    Id: string;
    Name: string;
}



/********************************Hardware model ***************************/

// export class HardwareModelBase {
//     HardwareId: string;
//     Localizations: Localization[];
//     Module: Module;
//     AvailableModules?: any;
//     AvailableTableDefinitions?: any;
//     TableDefinition: TableDefinition;
//     DataElementList: DataElementList[];
// }
// export class HardwareModel extends HardwareModelBase{
//     LocalizationId: string;
//     TranslationLocalizations: Localization[];
//     Name:string;
//     Text:string;
//     Text2:string;
//     Text3:string;
//     TableDefinitionId: string;
//     ModuleId: string;
//     hardwareTypId:number;
// }

// export interface Module {
//     Id: string;
//     Name: string;
// }

/********************************Module model ***************************/
// export class ModulModelBase {
//     ModuleId: string;
//     Localizations: Localization[];
//     Node: Node;
//     TableDefinition: TableDefinition;
//     DataElementList: DataElementList[];
// }

// export class ModulModel extends ModulModelBase {
//     LocalizationId: string;
//     TranslationLocalizations: Localization[];
//     Name:string;
//     Text:string;
//     Text2:string;
//     Text3:string;
//     TableDefinitionId: string;
//     NodeId: string;
//     ModuleTypId:number;
// }

// export interface Node {
//     Id: string;
//     Name: string;
// }


/********************************Node model ***************************/

// export class NodeModelBase {
//     NodeId: string;
//     Localizations: Localization[];
//     TableDefinition: TableDefinition;
//     DataElementList: DataElementList[];
//     ChildNodes: IdNameModel[];
//     Tags?: IdNameModel[];
// }


// export class NodeModel extends NodeModelBase{
//     LocalizationId: string;
//     TranslationLocalizations: Localization[];
//     Name:string;
//     Text:string;
//     Text2:string;
//     Text3:string;
//     TableDefinitionId: string;
//     NodeTypId:number;
// }


export class NameValue {
    Name: string;
    Value: number;
}

export class NameIdModel{
    id: string;
    name: string;
}